var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonProgress"},[_c('div',{staticClass:"percentage"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"slide"},[_c('el-progress',{attrs:{"show-text":false,"percentage":_vm.progress,"color":"#2F58FE","bacground":"#DCDDE0"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }